import { FC, useState } from 'react';
import styled, { css } from 'styled-components';

import Button from '@/components/Button';

const StyledButton = styled(Button)<{ $active?: boolean }>`
  width: 104px;
  padding: 0 16px;
  color: ${({ theme }) => theme.colors.gray};
  justify-content: center;
  &:hover,
  &:active {
    color: ${({ theme }) => theme.colors.black};
  }
  ${({ $active }) =>
    $active &&
    css`
      color: ${({ theme }) => theme.colors.black};
      border-color: rgba(34, 34, 34, 0.25);
    `}
`;

interface Props {
  idToCopy: number;
}

const CopyButton: FC<Props> = ({ idToCopy }) => {
  const [buttonText, setButtonText] = useState('Copy ID');

  const handleCopyClick = () => {
    navigator.clipboard.writeText(idToCopy.toString());
    setButtonText('Copied!');
    setTimeout(() => {
      setButtonText('Copy ID');
    }, 3000);
  };

  return (
    <StyledButton
      $active={buttonText === 'Copied!'}
      color="secondary"
      small
      onClick={handleCopyClick}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 10.5H13.5V2.5H5.5V5.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 5.5H2.5V13.5H10.5V5.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {buttonText}
    </StyledButton>
  );
};

export default CopyButton;
